export const ADB2C_TOKENS = "ADB2C_TOKENS";
export const SIGNIN_SIGNUP = "SIGNIN_SIGNUP";
